import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ConfirmModalDelivery from '../../../../../components/UI/ConfirmModal';
import { BackButton, Button } from '../../../../../components/UI/ComponentsUI';
import { getVision } from '../../../../../services/auth';
import { translate, enumText } from '../../../../../utils/util';
import { ENUMS, VISIONS } from '../../../../../utils/constants';
import LoweringService from '../../../../../services/LoweringService';
import RoutePickingService from '../../../../../services/RoutePickingService';
import * as loweringAction from '../../../../../actions/loweringAction';
import * as actionsPicking from '../../../../../actions/pickingAction';
import ConfirmModalStart from './ConfirmModalStart';
import { getUser } from '../../../../../services/auth';

const SmallPartsOnDemand = (props) => {
    const [orderGroup, setOrderGroup] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const getStatusOrder = (value) => translate(`expedition:${enumText(ENUMS.eOrderGroupStatus, value)}`);

    const onConfirmModal = () => {
        if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            return props.history.replace({
                pathname: `./orders/missions/list`
            });
        }
        const mission = props.order?.items?.find(o => o.status === ENUMS.eOrderItemStatus.Waiting.value || o.status === ENUMS.eOrderItemStatus.InProgress.value)
        if (mission.status === ENUMS.eOrderItemStatus.Waiting.value) {
            var order = props.orders.items.find(o => o.orderId === mission.orderId);
            props.setSelectedOrder(order);
            props.startOrder(order.orderId);
            props.startOrderItem(mission.orderId, mission.orderItemId, () => {
                props.history.replace({
                    pathname: `./order/missions/${mission.orderItemId}`
                });
                props.setSelectedMission(mission);
            });
        } else {
            props.history.replace({
                pathname: `./order/missions/${mission.orderItemId}`
            });
            props.setSelectedOrder(props.orders.items.find(o => o.orderId === mission.orderId));
            props.setSelectedMission(mission);
        }
    }

    useEffect(() => {
        if (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            setOpenModal(true);
            let filter = {};
            filter.userName = getUser().userName;
            props.getRouteUser(filter);
        }
        else {
            start();
        }
        // eslint-disable-next-line
    }, []);

    const start = () => {
        setOpenModal(false);
        props.filter.orderType = ENUMS.eOrderType.Lowering.value;
        props.filter.areas = props.areas;
        props.filter.sectors = props.sectors;
        if ((getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD)) {
            props.filter.almox = props.almox;
        }
        if (!props.location?.state?.filterRoute) {
            props.filter.routeCode = "";
        }
        props.getFirstOrder(props.filter, (data) => {
            setOrderGroup(data);
        });

        return () => {
            setOrderGroup({});
        };
    }

    const onClickConfirm = () => {
        confirm();
    }

    const confirm = () => {
        if (props.order.status === ENUMS.eOrderItemStatus.Waiting.value) {
            props.startOrder(props.order.orderId, () => {
                onConfirmModal();
            });
        } else {
            onConfirmModal();
        }
    };

    const leave = () => {
        if (orderGroup?.orderGroupId > 0) {
            props.leave(orderGroup.orderGroupId, false)
        }

        return props.history.go(-1);
    }

    const totalItems = () => {
        if (!props.orderGroup.orders) {
            return '';
        }
        const total = props.orderGroup.orders.length;
        const totalWaiting = props.orderGroup.orders.filter((i) => (
            i.status === ENUMS.eOrderStatus.Finished.value
            || i.status === ENUMS.eOrderStatus.ManuallyFinished.value
            || i.status === ENUMS.eOrderStatus.WaitingFinish.value)
            || i.items?.filter((m) => m.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length > 0).length;

        return `${(totalWaiting)}/${total}`;
    };

    return (
        <div>
            <BackButton {...props} onClick={() => leave()} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="subtitle">
                        <i className="material-icons">compare_arrows</i>
                        {translate('line-picking:linepicking.iniciatePicking')}
                    </div>
                </div>
            </div>
            {
                orderGroup && orderGroup.orderGroupId ?
                    (<div className="container" style={{ marginTop: '40px', }}>
                        <div className="col s12 subtitle">
                            <span style={{ display: 'inline-flex' }}>
                                {translate('line-picking:linepicking.status')}: {totalItems()}
                            </span>
                        </div>
                        <div className="card">
                            <div className="card-content" style={{ padding: '0px', }}>
                                <div className="row">
                                    <div className="col s12">
                                        <h4>{`${translate('line-picking:linepicking.group')} : ${orderGroup?.orderGroupId}`}</h4>
                                        {<p className="truncate">{`Area: ${props.orderGroup?.area || ''}`}</p>}
                                        {<p className="truncate">{`Rota: ${orderGroup?.route?.code}`}</p>}
                                        {<p className="truncate">{`Status: ${getStatusOrder(orderGroup?.status)}`}</p>}
                                    </div>
                                    {
                                        props.orderGroup.delivery &&
                                        <div className="col s12">
                                            <p style={{ color: 'red' }}>{translate('line-picking:messages.pending-dolly')}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="card-action row center">
                                <Button full="true" onClick={() => onClickConfirm()} text={translate('general:confirm')} />
                            </div>
                        </div>
                    </div>) : (<div className="container" style={{ textAlign: 'center', marginTop: '40px' }}>
                        {translate('general:no-registry')}
                    </div>)
            }
            <ConfirmModalStart
                open={openModal}
                dismissible={false}
                onConfirm={start}
                btnCancel={translate('general:cancel')}
                setFilter={props.setFilter}
                filter={props.filter}
                history={props.history}
                routes={props.routes.length > 0 ? props.routes[0].routes : []}
            />
            <ConfirmModalDelivery
                id="confirmModalDelivery"
                data={{ title: translate('validations:attention'), message: translate('line-picking:messages.pending-dolly-confirmation') }}
                onConfirm={confirm}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        orderGroup: state.loweringReducer.orderGroup,
        order: state.loweringReducer.order,
        filter: state.loweringReducer.filter,
        justifications: state.justificationReducer.justifications,
        orders: state.loweringReducer.orders,
        areas: state.loweringReducer.areas,
        area: state.loweringReducer.area,
        sectors: state.loweringReducer.sectors,
        routes: state.pickingReducer.routeUsers,
        almox: state.loweringReducer.almox
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilter: (filter) => {
            dispatch(actionsPicking.setFilter(filter));
        },
        getFirstOrder: (filter, callback) => {
            dispatch(LoweringService.firstOrder(filter, callback));
        },
        startOrder: (orderId, callback) => {
            dispatch(LoweringService.startOrder(orderId, callback));
        },
        leave: (orderGroupId, abandon) => {
            dispatch(LoweringService.leave(orderGroupId, abandon));
        },
        setSelectedOrder: (order) => {
            dispatch(loweringAction.selectOrder(order));
        },
        setSelectedMission: (mission) => {
            dispatch(loweringAction.selectMission(mission));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(LoweringService.startOrderItem(orderId, orderItemId, callback));
        },
        getRouteUser: (filter) => {
            dispatch(RoutePickingService.getRouteUser(filter));
        }

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsOnDemand)));
